exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3g0Y {\n    height: 40px;\n}\n\n._1KWJ, ._1KWJ:hover {\n    color: white;\n    font-size: 14px;\n    margin-right: 16px;\n    text-align: right;\n}\n", ""]);

// exports
exports.locals = {
	"logo": "_3g0Y",
	"link": "_1KWJ"
};